import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-ink/10 bg-white py-10 sm:py-14" data-id="element-176" data-mp="1tai2pb8gatrc">
      <div className="mx-auto max-w-6xl px-5" data-id="element-177" data-mp="1t8du4fzlx6kq">
        <h2 className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-178" data-mp="1oalzvfbhp8dd">
          <span aria-hidden="true" data-id="element-179" data-mp="1jd3nfey9kb0m">📊 </span>I Numeri Non Mentono
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-y-8 md:grid-cols-4 md:gap-y-0" data-id="element-180" data-mp="1ecz83s93dmbz">
          {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-ink/10' : ''}`} data-id="element-181" data-mp="19lz98hgewu6u" data-mpi={index}>
              <dt className="sr-only" data-id="element-182" data-mp="15lyuswtbcizs">{stat.label}</dt>
              <dd data-id="element-183" data-mp="10lt0t9zkmkej">
                <span className="block font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-184" data-mp="10mciqqp818sk">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.16em] text-ink/50 sm:text-xs" data-id="element-185" data-mp="vly8r3427orw">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}